// PproFullRegi -구매 전체 입고
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useAuth } from '../../../../../contexts/auth';
import { PagingGrid as MainGrid, PagingGrid as SubsGrid } from '../../../../script/components/data-grid/data-grid-body/grid-bodys';
import { CommCol, DateCol, DeciCol } from '../../../../script/components/data-grid/data-grid-column/grid-column';
import { PproFullRegiInsert } from './FullRegi-insert';
import { fwUtil } from '../../../../script/util';
import { FwAppLoader } from '../../../../script/components/load-panel/load-panel';

export default function PproFullRegi(props) {
    const {
        acce, gubu, cata, catb, code,
        mainTitle, mainRole, 
        subsTitle, subsRole,
    } = props; 

    // api
    const mainSearchApi = `${acce}/${gubu}/${cata}/${catb}/regist/docn/header/search`; // 메인 조회 api
    const mainInsertApi = `${acce}/${gubu}/${cata}/${catb}/regist/docn/header/insert`; // 메인 등록 api
    const subsSearchApi = `${acce}/${gubu}/${cata}/${catb}/regist/docn/detail/search`; // 서브 조회 api
    // 시스템
    const [loading, setLoading] = useState(true);
    // 권한
    const { authCheck } = useAuth();
    const [authList, setAuthList] = useState([]);
    // 그리드
    const gridSize = "dual";
    const mainKey = 'ppro_numb';
    const subsKey = ['ppro_numb', 'ppro_seri'];
    const mainGridRef = useRef(null);
    const [mainGridData, setMainGridData] = useState([]);
    const mainGridDataUpdate = useCallback((e) => setMainGridData(e), []);        
    const subsGridRef = useRef(null);
    const [subsGridData, setSubsGridData] = useState([]);
    const subsGridDataUpdate = useCallback((e) => setSubsGridData(e), []);    
    // 검색 조건
    const [dateValue, setDateValue] = useState(fwUtil.date.getsText.range());
    const [duraYesn, setDuraYesn] = useState(true);
    const [pproNumb, setPproNumb] = useState("");
    const [clieName, setClieName] = useState("");
    const [matlCode, setMatlCode] = useState("");
    const dateValueChange= useCallback((e) => { setDateValue([e.value[0], e.value[1]]) }, []);
    const duraYesnChange = useCallback((e) => { setDuraYesn(e.value) }, []);
    const pproNumbChange = useCallback((e) => { setPproNumb(e) }, []);
    const clieNameChange = useCallback((e) => { setClieName(e) }, []);
    const matlCodeChange = useCallback((e) => { setMatlCode(e) }, []);
    // 등록 팝업창
    const [mainInsertPopupVisible, setMainInsertPopupVisible] = useState(false);
    const mainInsertPopupHide = useCallback(() => { setMainInsertPopupVisible(false); }, []);

    // 조회
    const mainHandleSearch = useCallback(async () => {
        const sendData = { start: dateValue[0], compl: dateValue[1], duraYesn: duraYesn, pproNumb: pproNumb, matlCode: matlCode, clieName: clieName };        
        await fwUtil.apis.search(mainSearchApi, sendData, mainGridDataUpdate, mainGridRef, subsGridRef);
    }, [dateValue, duraYesn, pproNumb, matlCode, clieName, mainSearchApi, mainGridDataUpdate]);

    const subsHandleSearch = useCallback(async (key) => {
        const keyData = key;
        if (keyData) {
            const sendData = { pproNumb: keyData };
            await fwUtil.apis.search(subsSearchApi, sendData, subsGridDataUpdate, subsGridRef, null);
        }
    }, [subsSearchApi, subsGridDataUpdate]);

    useEffect(() => {
        mainHandleSearch();
    }, [mainHandleSearch]);

    const mainGridClick = useCallback(({ key }) => {
        if (key) {
            subsHandleSearch(key);
        }
    }, [subsHandleSearch]);

    // 접근 권한 조회 및 권한 상태값 설정
    useEffect(() => {
        authCheck(setLoading, setAuthList, gubu, code);
    }, [authCheck, setLoading, setAuthList, gubu, code]);

    // 추가 툴바 아이템
    const toolbarItems = useMemo(() => [
        { type: 'text', locate: 'before', caption: '발주번호', value: pproNumb, valueChange: pproNumbChange, search: mainHandleSearch },
        { type: 'text', locate: 'before', caption: '업체명', value: clieName, valueChange: clieNameChange, search: mainHandleSearch },
        { type: 'text', locate: 'before', caption: '자재번호', value: matlCode, valueChange: matlCodeChange, search: mainHandleSearch },
        { type: 'btns', locate: 'before', icon: 'search', text: '검색', onClick: mainHandleSearch }
    ], [pproNumb, pproNumbChange, clieName, clieNameChange, matlCode, matlCodeChange, mainHandleSearch]);

    // 등록 버튼 클릭
    const mainHandleInsertClick = useCallback(() => {
        const mainSelectedRowKey = fwUtil.grid.get.sKey(mainGridRef);

        if (mainSelectedRowKey) {
            setMainInsertPopupVisible(true);
        } else {
            fwUtil.aler.toast.nsWarn();
        };

    }, [mainGridRef]);

    return (
        <div className='fw-grid-page fw-flex-box col'>
            <FwAppLoader loading={loading} />
            <MainGrid
                title={mainTitle}
                role={mainRole}
                gridSize={gridSize}
                mainKey={mainKey}
                gridRef={mainGridRef}
                gridDataSource={mainGridData}
                dateValue={dateValue}
                dateValueChange={dateValueChange}
                duraYesn={duraYesn}
                duraYesnChange={duraYesnChange}
                onRowClick={mainGridClick}
                ins={{ onClick: mainHandleInsertClick, disabled: authList.auth_inse === 0 }}
                exp={{ disabled: authList.auth_dnlo === 0 }}                
                toolbar={{ default: true, items: toolbarItems }}
                selection={'multiple'}
            >
                {CommCol({ dataField: "ppro_numb", caption: "발주번호" })} 
                {CommCol({ dataField: "clie_name", caption: "업체명" })} 
                {CommCol({ dataField: "clie_teln", caption: "업체전화" })} 
                {CommCol({ dataField: "clie_faxn", caption: "업체팩스" })} 
                {CommCol({ dataField: "clie_damd", caption: "업체담당자" })} 
                {DateCol({ dataField: "pdel_date", caption: "납품일자" })} 
                {CommCol({ dataField: "pays_cond", caption: "지불형태" })} 
                {CommCol({ dataField: "deli_plac", caption: "납품장소" })} 
                {CommCol({ dataField: "ppro_remk", caption: "특기사항" })} 
                {CommCol({ dataField: "damd_name", caption: "발주담당자" })} 
                {DateCol({ dataField: "ppro_date", caption: "발주일자" })} 
                {CommCol({ dataField: "ppro_usag", caption: "용도" })} 
                {CommCol({ dataField: "ppro_stat", caption: "진행상태" })}                              
                {CommCol({ dataField: "afte_conf", caption: "결재진행" })}                              
                {DateCol({ dataField: "rele_date", caption: "발주처리일" })}                              
            </MainGrid>
            <PproFullRegiInsert
                mainGrid={mainGridRef}
                mainRefresh={mainHandleSearch}
                subsRefresh={subsHandleSearch}
                insertApi={mainInsertApi}
                visible={mainInsertPopupVisible}
                hiding={mainInsertPopupHide}
            />
            <SubsGrid
                title={subsTitle}
                role={subsRole}
                gridSize={gridSize}
                mainKey={subsKey}
                gridRef={subsGridRef}
                gridDataSource={subsGridData}
                selection={'single'}
                toolbar={{ default: false }}
            >
                {CommCol({ dataField: "ppro_numb", caption: "발주번호" })} 
                {CommCol({ dataField: "ppro_seri", caption: "순번" })}
                {CommCol({ dataField: "matl_code", caption: "자재번호" })}
                {CommCol({ dataField: "matl_name", caption: "자재품명" })}
                {CommCol({ dataField: "matl_spec", caption: "자재규격" })}
                {DeciCol({ dataField: "rece_qtys", caption: "기입고량" })}
                {DeciCol({ dataField: "ppro_qtys", caption: "발주수량" })}
                {DeciCol({ dataField: "ppro_weig", caption: "발주중량" })}
                {CommCol({ dataField: "puro_unit", caption: "구매단위" })}
                {DeciCol({ dataField: "ppro_pric", caption: "발주단가" })}
                {DeciCol({ dataField: "ppro_cwon", caption: "발주금액" })}
                {CommCol({ dataField: "rece_plac", caption: "납품장소" })}
                {CommCol({ dataField: "ppro_memo", caption: "비고" })}
            </SubsGrid>                            
        </div>
    );
};